import { SVGProps } from 'react';

export type SVGRProps = {
  title?: string;
  titleId?: string;
};

const SvgInterfaceinfo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    aria-labelledby={titleId}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M11.094 5.146h1.832v1.85h-1.832v-1.85Zm.926 15.806a8.933 8.933 0 1 1 .032-17.866 8.933 8.933 0 0 1-.028 17.866h-.004Zm-.845-12.164h1.669v9.817h-1.669V8.788ZM12.024 22a10 10 0 1 0-.048-20 10 10 0 0 0 .048 20Z"
      fill={props.color}
    />
  </svg>
);

export default SvgInterfaceinfo;
